"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const text_1 = require("../text");
const theme_provider_1 = require("../theme-provider");
const StyledListItem = theme_provider_1.styled.li.withConfig({ displayName: "StyledListItem", componentId: "sc-p8582k" }) `
	display: grid;
	grid-template-columns: max-content auto;
	align-items: center;
	margin-top: ${props => props.gutter ? props.theme.size[props.gutter] : props.theme.size.static300};
	margin-bottom: ${props => props.gutter ? props.theme.size[props.gutter] : props.theme.size.static300};
	grid-column-gap: 1em;
`;
const StyledFlexItem = theme_provider_1.styled.div.withConfig({ displayName: "StyledFlexItem", componentId: "sc-j1d6y7" }) `
	vertical-align: middle;
`;
const Marker = (props) => {
    const { index = 0, isOrdered = false, markerSize = 0 } = props;
    return isOrdered ? (React.createElement(text_1.Text, { bold: true },
        index.toString().padStart(markerSize, '0'),
        " ")) : (React.createElement(text_1.Text, { bold: true }, "\u2014 "));
};
const convertPlainTextToTextComponent = (children) => {
    if (typeof children === 'string') {
        return React.createElement(text_1.Text, null, children);
    }
    return children;
};
exports.ListItem = props => {
    const { children, index, isOrdered = false, gutter, markerSize } = props;
    return (React.createElement(StyledListItem, { isOrdered: isOrdered, index: index, gutter: gutter, markerSize: markerSize },
        React.createElement(StyledFlexItem, null,
            React.createElement(Marker, { isOrdered: isOrdered, index: index, markerSize: markerSize }, children)),
        React.createElement(StyledFlexItem, null, convertPlainTextToTextComponent(children))));
};
